export type DevicePrivilege = string | number;

const devicePrivilegeLabels: Record<string, string> = {
  '0': 'Usuario normal',
  '2': 'Registrador',
  '6': 'Administrador',
  '10': 'Personalizado',
  '14': 'Superadministrador',
};

export type DevicePrivilegePresentation = {
  rawValue: string | null;
  label: string;
  known: boolean;
  administrator: boolean;
};

export const getDevicePrivilegePresentation = (
  privilege?: DevicePrivilege | null
): DevicePrivilegePresentation => {
  if (
    privilege === undefined ||
    privilege === null ||
    String(privilege).trim() === ''
  ) {
    return {
      rawValue: null,
      label: 'Sin dato del dispositivo',
      known: false,
      administrator: false,
    };
  }

  const rawValue = String(privilege);
  const label = devicePrivilegeLabels[rawValue];

  return {
    rawValue,
    label: label || `Desconocido (${rawValue})`,
    known: Boolean(label),
    administrator: rawValue === '6' || rawValue === '14',
  };
};
